module.exports = __webpack_public_path__ + "static/media/logo-light.982f7cc9.svg";